import { useState } from 'react';
import { motion } from 'framer-motion';
import toast from 'react-hot-toast';

const wrapperVariants = {
  open: { opacity: 1, height: 'auto', transition: { duration: 0.3 } },
  closed: { opacity: 0, height: 0, transition: { duration: 0.2 } },
};

const ChangeUTC = ({ utcOptions, selectedUTC, setSelectedUTC }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleUTCChange = (utc) => {
    setSelectedUTC(utc);
    setIsOpen(false);
    toast.success(`Selected: ${utc.label}`);
  };

  return (
    <div className="p-4">
      <h2 className="mb-2 text-lg font-semibold text-slate-700">
        Select Cycle
      </h2>

      <motion.div animate={isOpen ? 'open' : 'closed'} className="relative">
        {/* Dropdown Button */}
        <button
          onClick={toggleDropdown}
          className="w-24 rounded-md border border-slate-400 bg-white px-4 py-2 text-sm font-medium text-slate-800 shadow-md transition-all duration-300 hover:border-blue-500 hover:bg-slate-100"
        >
          {selectedUTC.label}
        </button>

        {/* Dropdown Menu */}
        <motion.ul
          initial={wrapperVariants.closed}
          variants={wrapperVariants}
          className="absolute left-0 top-[120%] z-10 w-36 overflow-hidden rounded-md border border-slate-300 bg-white shadow-lg"
        >
          {utcOptions.map((utc) => (
            <motion.li
              key={utc.value}
              onClick={() => handleUTCChange(utc)}
              className={`cursor-pointer px-4 py-2 text-sm text-slate-800 transition duration-300 ${
                selectedUTC.value === utc.value
                  ? 'bg-blue-500 font-semibold text-white'
                  : 'hover:bg-slate-100'
              }`}
            >
              {utc.label}
            </motion.li>
          ))}
        </motion.ul>
      </motion.div>
    </div>
  );
};

export default ChangeUTC;
